import { type HTMLAttributes, type Ref } from 'react';
import clsx from 'clsx';
import './Badges.css';

export interface GemsCounterProps extends HTMLAttributes<HTMLSpanElement> {
  gems: number;
  size?: 'sm' | 'md' | 'lg';
  ref?: Ref<HTMLSpanElement>;
}

/**
 * GemsCounter — blue gem + count pill.
 *
 * ⚠ Built unused in MVP (DECISIONS.md: "No hearts / gems / leagues in v1").
 * Ships with the design system so v1.1+ or A/B tests can enable it
 * without rebuilding from scratch.
 */
export function GemsCounter({ gems, size = 'md', className, ref, ...rest }: GemsCounterProps) {
  return (
    <span
      ref={ref}
      className={clsx('fluent-badge', className)}
      data-kind="gems"
      data-size={size}
      aria-label={`${gems} gems`}
      {...rest}
    >
      <span className="fluent-badge__icon" aria-hidden="true">
        <GemIcon />
      </span>
      <span className="fluent-badge__value">{gems.toLocaleString('ka-GE')}</span>
    </span>
  );
}

function GemIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <path d="M6 3h12l4 6-10 12L2 9l4-6zm.7 2L4.4 8h4.3L9.8 5H6.7zm10.6 0h-3.1l1.1 3h4.3L17.3 5zM5.1 10l6.9 8.3 6.9-8.3H5.1z" />
    </svg>
  );
}
